import React, { FC, useState } from 'react'
import { SelectProps as AntSelectProps } from 'antd/lib/select'
import { Select as AntSelect } from 'antd'
import { Icon } from '@iconify/react'

import { Tag, Button, Input } from '../../atoms'

import styles from './_.module.css'

interface Props extends AntSelectProps<string> {
  addItem: (value: string) => void
}

export const AddInSelect: FC<Props> = ({
  mode,
  bordered,
  className,
  defaultValue,
  disabled,
  maxTagCount,
  onBlur,
  onChange,
  placeholder,
  optionFilterProp,
  options,
  size,
  value,
  addItem
}) => {
  const [text, setText] = useState('')

  const updateText = (textFieldData: string) => {
    if (!textFieldData?.trim()) {
      setText('')
    } else {
      setText(textFieldData)
    }
  }

  const tagRender = (props: any) => {
    const { label, closable, onClose } = props

    // if the tag is closable means that it is the maxCount placeholder
    if (!closable) {
      return <span className={styles.maxPlaceholder}>{label}</span>
    }

    return (
      <Tag className={styles.selectTag} closable={closable} onClose={onClose}>
        <span className={styles.selectTagLabel}>{label}</span>
      </Tag>
    )
  }

  return (
    <div>
      <AntSelect
        mode={mode}
        tagRender={tagRender}
        dropdownRender={menu => (
          <div>
            {menu}

            <div className={styles.addOptions}>
              <Input
                className={styles.selectInput}
                value={text}
                onChange={e => updateText(e.target.value)}
                size="middle"
              />
              <Button
                className={styles.addBtn}
                icon={<Icon icon="ant-design:plus-outlined" />}
                type="link"
                disabled={!text}
                onClick={() => {
                  addItem(text)
                  setText('')
                }}
              >
                Add Custom
              </Button>
            </div>
          </div>
        )}
        className={className}
        bordered={bordered}
        defaultValue={defaultValue}
        disabled={disabled}
        onBlur={onBlur}
        options={options}
        optionFilterProp={optionFilterProp}
        placeholder={placeholder}
        optionLabelProp="label"
        size={size}
        maxTagCount={maxTagCount}
        maxTagPlaceholder={item => {
          return `+${item.length}`
        }}
        value={value}
        onChange={onChange}
      >
        {options?.map(option => (
          <AntSelect.Option
            value={option.value}
            label={option.label}
            key={option.value}
          >
            {option.label}
          </AntSelect.Option>
        ))}
      </AntSelect>
    </div>
  )
}
